//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import { IAugmentedJQuery, IControllerConstructor, Injectable } from 'angular';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { ThemeProvider } from 'styled-components';

import { ICuralateStore } from '@models/AppState';
import { ReactQueryProvider } from '@queries/ReactQueryProvider';

/**
 * Creates an Angular Component Controller that initializes a new React App with the given component.
 * @param component React Component/HTML to initialize
 */
export default function makeAngularReactController(
  component: React.ReactNode,
): Injectable<IControllerConstructor> {
  return [
    '$ngRedux',
    '$element',
    ($ngRedux: Store<ICuralateStore>, $element: IAugmentedJQuery) => {
      const node = $element[0] ?? null;
      let root: Root | null = null;

      if (node) {
        root = createRoot(node);
        root.render(
          <ThemeProvider theme={theme}>
            <Provider store={$ngRedux}>
              <ReactQueryProvider>{component}</ReactQueryProvider>
            </Provider>
          </ThemeProvider>,
        );
      }

      return {
        $onDestroy: () => {
          if (root) {
            root.unmount();
          }
        },
      };
    },
  ];
}
